import { render } from "./ModalPriceRuleDetails.vue?vue&type=template&id=0cf6494a"
import script from "./ModalPriceRuleDetails.vue?vue&type=script&lang=js"
export * from "./ModalPriceRuleDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__